import React from 'react';
import styles from './pillLoader.module.scss';
import { PillLoaderViewModel } from 'src/types/view-models/atoms/pill-loader.view.model';
import Selectors from 'src/utils/selectors';

export default function PillLoader({ className }: PillLoaderViewModel): JSX.Element {
    return (
        <div className={`${styles.pillContainer} ${className}`} data-cy={Selectors.General.LOADING_INDICATOR}>
            <div className={styles.pill} />
            <div className={styles.pill} />
            <div className={styles.pill} />
        </div>
    );
}
